import { withInstall, withNoopInstall } from '@element-plus/utils'

import Skeleton from './src/skeleton.vue'
import SkeletonItem from './src/skeleton-item.vue'
import SkeletonGrid from './src/skeleton-grid.vue'
import SkeletonTable from './src/skeleton-table.vue'

export const ElSkeleton = withInstall(Skeleton, {
  SkeletonItem,
  SkeletonGrid,
  SkeletonTable,
})
export const ElSkeletonItem = withNoopInstall(SkeletonItem)
export const ElSkeletonGrid = withNoopInstall(SkeletonGrid)
export const ElSkeletonTable = withNoopInstall(SkeletonTable)
export default ElSkeleton

export * from './src/skeleton'
export * from './src/skeleton-item'
export * from './src/skeleton-grid'
export * from './src/skeleton-table'
